import { useTranslation } from "react-i18next";

import { Spacer, Stepper, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./PractitionerOnboardingStepper.styles";

interface Props {
  currentStep: number;
}

const PractitionerOnboardingStepper = ({ currentStep }: Props) => {
  const { phoneLarge } = useBreakpoints();
  const { t } = useTranslation();

  const STEPS = [
    { label: t(l.practitionerSignUp.PracOnboarding.steps.AccountCreation) },
    { label: t(l.practitionerSignUp.PracOnboarding.steps.SignUp) },
    { label: t(l.practitionerSignUp.PracOnboarding.steps.AccountGoals) },
    { label: t(l.practitionerSignUp.PracOnboarding.steps.Credentials) },
    { label: t(l.practitionerSignUp.PracOnboarding.steps.Confirmation) },
  ];

  if (phoneLarge.lessThan) {
    const text = `${t(l.practitionerSignUp.PracOnboarding.steps.Step)} ${currentStep}/${
      STEPS.length
    }`;

    return (
      <Typography type="h5" css={styles.mobileText}>
        <strong>{text}</strong>
      </Typography>
    );
  }

  return (
    <>
      <Stepper size="small" steps={STEPS} currentStep={currentStep} />
      <Spacer height="oneHalf" />
    </>
  );
};

export { PractitionerOnboardingStepper };
